/* tslint:disable:variable-name */
import {Directive, ElementRef, EventEmitter, Inject, Input, OnDestroy, OnInit, Optional, Output} from '@angular/core';
import {TableComponent} from '@blocks/table/table.component';
import {BlockStore} from '@blocks/block/block.store';
import {BLOCKS_CONFIG, BlocksConfig} from '@blocks/blocks.config';
import {BlockChangeDetectionService} from '@blocks/services/block-change-detection/block-change-detection.service';
import {Subscription} from 'rxjs';
import {TableService} from '@blocks/table/table.service';
import {BlockMutationService} from '@blocks/services/block-mutation/block-mutation.service';

@Directive({
  selector: 'table[addDelete]',
  exportAs: 'addDelete'
})
export class TableAddDeleteDirective implements OnInit, OnDestroy {
  @Output() colAdded = new EventEmitter<void>();
  @Output() rowAdded = new EventEmitter<void>();
  @Output() colRemoved = new EventEmitter<void>();
  @Output() rowRemoved = new EventEmitter<void>();

  private subs = new Subscription();

  constructor(
    private elementRef: ElementRef,
    private tableService: TableService,
    private tc: TableComponent,
    private blockMutationService: BlockMutationService,
    private blockChangeDetectionService: BlockChangeDetectionService,
    @Optional() private blockStore: BlockStore,
    @Optional() @Inject(BLOCKS_CONFIG) private blocksConfig: BlocksConfig) {
  }

  private _addDelete: boolean;

  get addDelete(): boolean {
    return this._addDelete;
  }

  @Input()
  set addDelete(value: boolean) {
    this._addDelete = value;
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  addColAtIndex(index: number) {
    this.blockMutationService.begin(this.tc.block.bucket_type, this.tc.block.bucket_id);
    this.tableService.addColAtIndex(this.tc.block, index);
    this.subs.add(this.blockMutationService.commit().subscribe(r => {
      this.colAdded.emit();
    }));
  }

  addRowAtIndex(index: number) {
    this.blockMutationService.begin(this.tc.block.bucket_type, this.tc.block.bucket_id);
    this.tableService.addRowAtIndex(index);
    this.subs.add(this.blockMutationService.commit().subscribe(r => {
      this.rowAdded.emit();
    }));
  }

  removeColAtIndex(index: number) {
    this.blockMutationService.begin(this.tc.block.bucket_type, this.tc.block.bucket_id);
    this.tableService.removeColAtIndex(this.tc.block, index);
    this.subs.add(this.blockMutationService.commit().subscribe(r => {
      this.colRemoved.emit();
    }));
  }

  removeRowAtIndex(index: number) {
    this.blockMutationService.begin(this.tc.block.bucket_type, this.tc.block.bucket_id);
    this.tableService.removeRowAtIndex(index);
    this.subs.add(this.blockMutationService.commit().subscribe(r => {
      this.rowRemoved.emit();
    }));
  }
}
